import { useState, useEffect } from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { isLimitless, isAdRev } from '../domainSupport';
import config from '../../../configWrapper';

export default function useAgency() {
  const [agency, setAgency] = useState(null);
  const [matchAgency, setMatchAgency] = useState(null);
  const [onboardingAgency, setOnboardingAgency] = useState(null);
  const [searchParams, setSearchParams] = useState(null);
  const [onboardingId, setOnboardingId] = useState(null);
  const match = useRouteMatch({
    path: '/onboarding/:adPlatform/:agencyCode',
    exact: false,
  });
  const location = useLocation();

  useEffect(() => {
    const params = (match && match.params ? match.params : '') || '';
    // Accept any agency code from URL - logo file existence will validate it
    const agencyCode = params && params.agencyCode ? match.params.agencyCode : '';
    setMatchAgency(agencyCode);
  }, [match, setMatchAgency]);

  useEffect(() => {
    const { search } = location;
    if (search) {
      setSearchParams(search);
    }
  }, [location, setSearchParams]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    const id = params.get('state');
    if (id && id > 0) {
      setOnboardingId(id);
    }
  }, [searchParams, setOnboardingId]);

  useEffect(() => {
    // this is used when we have a return url and we need to deterime the agency with state parameter
    function getOnboardingAgency(id) {
      const onboardAgencyUrl = `${config.serverUrl}/onboarding/get-onboard-agency?state=${id}`;
      return fetch(onboardAgencyUrl, { headers: config.jsonHeader })
        .then((results) => {
          if (!results.ok) {
            throw results;
          }
          return results.json();
        })
        .then(data => data.agency || '')
        .catch(() => '');
    }
    if (onboardingId) {
      getOnboardingAgency(onboardingId).then((agencyCode) => {
        // Accept any agency code - logo file existence will validate it
        setOnboardingAgency(agencyCode || '');
      });
    }
  }, [onboardingId, setOnboardingAgency]);

  useEffect(() => {
    let finalAgency = '';
    if (matchAgency !== '') {
      finalAgency = matchAgency;
    } else if (onboardingAgency !== '') {
      finalAgency = onboardingAgency;
    } else if (isLimitless()) {
      finalAgency = 'limitless';
    } else if (isAdRev()) {
      finalAgency = 'adrev';
    } else {
      finalAgency = 'adjuggernaut';
    }
    setAgency(finalAgency);
  }, [matchAgency, onboardingAgency, setAgency]);

  return agency;
}
